// Configuration centralisée des URLs d'API
export const API_BASE_URL = (process.env.REACT_APP_API_URL || '') + '/api';

// Helper pour construire les URLs d'API
export const buildApiUrl = (endpoint: string): string => {
  return `${API_BASE_URL}${endpoint.startsWith('/') ? endpoint : `/${endpoint}`}`;
};

// URLs d'API communes
export const API_ENDPOINTS = {
  // Auth (utilisés avec fetch direct)
  LOGIN: buildApiUrl('/auth/login'),
  PROFILE: buildApiUrl('/auth/profile'),
  COMPLETE_MFA_LOGIN: buildApiUrl('/auth/complete-mfa-login'),
  
  // Users (utilisés avec apiService)
  USERS_PREFERENCES: '/users/preferences',
  CHANGE_PASSWORD: '/users/change-password',
  
  // MFA (utilisés avec apiService)
  MFA_STATUS: '/mfa/status',
  MFA_GENERATE_SECRET: '/mfa/generate-secret',
  MFA_ENABLE: '/mfa/enable',
  MFA_DISABLE: '/mfa/disable',
  MFA_VERIFY_TOTP: '/mfa/verify-totp',
  MFA_VERIFY_BACKUP_CODE: '/mfa/verify-backup-code',
  MFA_REGENERATE_CODES: '/mfa/regenerate-backup-codes',
  
  // Clients (utilisés avec fetch direct)
  CLIENTS: buildApiUrl('/clients'),
  
  // SIRET/SIREN (utilisés avec apiService)
  SIRET_LOOKUP: (siret: string) => buildApiUrl(`/siret/siret/${siret}`),
  SIREN_LOOKUP: (siren: string) => buildApiUrl(`/siret/siren/${siren}`),
  SIRET_VALIDATE: (siret: string) => buildApiUrl(`/siret/validate/siret/${siret}`),
  SIREN_VALIDATE: (siren: string) => buildApiUrl(`/siret/validate/siren/${siren}`),
  
  // Uploads (utilisés avec fetch direct)
  UPLOAD_FILE: buildApiUrl('/upload/file'),
  UPLOAD_PHOTO: buildApiUrl('/upload/photo'),
  
  // Enquetes (utilisés avec apiService)
  ENQUETES: '/enquetes',
  ENQUETE_BY_ID: (id: string) => `/enquetes/${id}`,
  ENQUETES_STATS: '/enquetes/stats',
  
  // OSINT (utilisés avec apiService)
  OSINT_SEARCH_EMAIL: '/osint/search/email',
  OSINT_SEARCH_USERNAME: '/osint/search/username',
  OSINT_PLATFORMS: '/osint/platforms',
  OSINT_TEST_PLATFORM: (platform: string) => `/osint/test/${platform}`,
  
  // Personnes (utilisés avec apiService)
  PERSONNES: '/personnes',
  PERSONNE_BY_ID: (id: string) => `/personnes/${id}`,
  
  // Lieux (utilisés avec apiService)
  LIEUX: '/lieux',
  LIEU_BY_ID: (id: string) => `/lieux/${id}`,
  
  // Notes (utilisés avec apiService)
  NOTES: '/notes',
  NOTE_BY_ID: (id: string) => `/notes/${id}`,
  
  // Fichiers (utilisés avec apiService)
  FICHIERS: '/fichiers',
  FICHIER_BY_ID: (id: string) => `/fichiers/${id}`,
  FICHIERS_BY_ENQUETE: (enqueteId: string) => `/fichiers/enquete/${enqueteId}`,
  
  // Photos (utilisés avec apiService)
  PHOTOS: '/photos',
  PHOTO_BY_ID: (id: string) => `/photos/${id}`,
  PHOTOS_BY_ENQUETE: (enqueteId: string) => `/photos/enquete/${enqueteId}`,
  
  // Health (utilisés avec fetch direct)
  HEALTH: buildApiUrl('/health'),
  
  // Reports (utilisés avec apiService)
  REPORTS: '/reports',
  REPORT_TEMPLATES: '/reports/templates',
  REPORT_GENERATE: '/reports/generate',
  REPORT_BY_ID: (id: string) => `/reports/${id}`,
  REPORT_DOWNLOAD: (id: string) => `/reports/${id}/download`,
  
  // Administration (utilisés avec apiService)
  ADMIN_STATS: '/admin/stats',
  ADMIN_USERS: '/admin/users',
  ADMIN_INVITE_USER: '/admin/users/invite',
  ADMIN_UPDATE_USER: (userId: string) => `/admin/users/${userId}`,
  ADMIN_DELETE_USER: (userId: string) => `/admin/users/${userId}`,
  ADMIN_PENDING_INVITATIONS: '/admin/invitations/pending',
  ADMIN_RESEND_INVITATION: (invitationId: string) => `/admin/invitations/${invitationId}/resend`,
  
  // Activation de compte (utilisé avec fetch direct)
  ADMIN_ACTIVATE_ACCOUNT: buildApiUrl('/admin/activate-account'),
} as const;